const { trackGtm4 } = require('util/functions');

module.exports = {
	init() {
		this.root.querySelectorAll('.calendar-menu--item').forEach(element => {
			element.addEventListener('click', this.gtmTracking.bind(this));
		});
	},
	gtmTracking({ target }) {
		const name = this.root
			.querySelectorAll('.event-highlight-partial--description')[1]
			?.textContent.trim();
		const date = this.root
			.querySelectorAll('.event-highlight-partial--date')[1]
			?.textContent.trim();

		trackGtm4({
			event: 'GA4_event_c_add_to_calendar',
			widget_name: 'V3-Investor-event-highlight',
			calendar_platform: target.textContent.trim(),
			cat_event_name: name,
			event_date: date,
		});
	},
};
